import React from 'react';

const ArrowDown = ({ color = '#7F7182' }) => (
  <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.9998 6.73848C5.86647 6.73848 5.74147 6.71764 5.6248 6.67598C5.50814 6.63431 5.3998 6.56348 5.2998 6.46348L0.699805 1.86348C0.516471 1.68014 0.424805 1.44681 0.424805 1.16348C0.424805 0.880143 0.516471 0.64681 0.699805 0.463477C0.883138 0.280143 1.11647 0.188477 1.3998 0.188477C1.68314 0.188477 1.91647 0.280143 2.0998 0.463477L5.9998 4.36348L9.89981 0.463477C10.0831 0.280143 10.3165 0.188477 10.5998 0.188477C10.8831 0.188477 11.1165 0.280143 11.2998 0.463477C11.4831 0.64681 11.5748 0.880143 11.5748 1.16348C11.5748 1.44681 11.4831 1.68014 11.2998 1.86348L6.6998 6.46348C6.5998 6.56348 6.49147 6.63431 6.3748 6.67598C6.25814 6.71764 6.13314 6.73848 5.9998 6.73848Z"
      fill={color}
    />
  </svg>
);

export default ArrowDown;
